import React, { useEffect, useState } from "react"
import useLocales from "hooks/useLocales"
import useAuth from "hooks/useAuth"
import checkPermissions from "helper/checkPermissions"
import PropTypes from "prop-types"
import { Layout, Menu as AntdMenu, theme, Image } from "antd"
import styled from "styled-components"
import { NAV_ITEM } from "configs"
import { useLocation, Link } from "react-router-dom"
import useCollapse from "hooks/useCollapse"

import { ReactComponent as MiniLogo } from "assets/icon/mini_logo_cloudtime.svg"
import { ReactComponent as FullLogo } from "assets/icon/full_logo_cloudtime.svg"

const { Sider } = Layout
const { useToken } = theme

export default function Sidebar({ collapsed }) {
  const { user } = useAuth()
  const { isCollapse } = useCollapse()
  const location = useLocation()
  const { token } = useToken()
  const { translate } = useLocales()

  const Menu = styled(AntdMenu)(({ token }) => ({
    border: "none !important",
    borderInline: "none !important",
    margin: "24px 0px",
    "&& .ant-menu-item-selected": {
      color: collapsed ? token.colorPrimary : token.colorTextBase,
      borderRadius: "0px 100px 100px 0px"
    }
  }))
  const [navbar, setNavbar] = useState([])
  useEffect(() => {
    const navbar = checkPermissionNavbar()
    setNavbar(navbar)
  }, [])

  const sidebarNavFlat = NAV_ITEM.reduce(
    (result, current) => result.concat(current.children && current.children.length > 0 ? current.children : current),
    []
  )

  const currentMenuItem = sidebarNavFlat.find(({ url }) => {
    // find url match with location.pathname include sub path
    return url === location.pathname && location.pathname.includes(url)
  })
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : []

  const flattenNavItems = (navItems) => {
    return navItems.reduce((result, item) => {
      if (item.type === "group") {
        result.push(...item.children)
      } else {
        result.push(item)
      }
      return result
    }, [])
  }

  const getChildren = (nav) => ({
    key: nav.key,
    label: nav?.children?.length ? translate(nav.title) : <Link to={nav.url || ""}>{translate(nav.title)}</Link>,
    title: translate(nav.title),
    icon: nav.icon,
    children: nav?.children?.map((children) => getChildren(children))
  })

  const checkPermissionNavbar = () => {
    let navItem = [...NAV_ITEM]

    // filter display:false ออก
    navItem = navItem.map((item) => {
      const children = item.children.filter((child) => child.display)
      return { ...item, children }
    })

    const navbar = navItem.map((item) => {
      const menu = item.children.filter((menu) => {
        const menu_name = menu.permission_key || menu.key
        const canView = checkPermissions(user?.permission, menu_name, "view")
        return canView
      })

      return { ...item, children: menu }
    })

    // remove emthy children
    const filterNavbar = navbar.filter((item) => item.children.length > 0)

    return filterNavbar
  }

  return (
    <Sider
      theme="light"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{
        height: "100vh",
        top: 0,
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div style={{ height: "calc(100vh - 80px)", overflowY: "auto" }}>
        {/* โลโก้ด้านบน — ไม่ scroll */}
        <div
          style={{
            position: "sticky",
            top: 0,
            paddingTop: "24px",
            paddingBottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white",
            zIndex: 10
          }}
        >
          <Link to="/" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {collapsed ? (
              <MiniLogo
                style={{
                  width: "50%",
                  height: "auto",
                  cursor: "pointer"
                }}
              />
            ) : (
              <FullLogo
                style={{
                  width: "85%",
                  height: "auto",
                  cursor: "pointer"
                }}
              />
            )}
          </Link>
        </div>

        <Menu
          token={token}
          defaultSelectedKeys={defaultSelectedKeys}
          items={
            !collapsed
              ? navbar.map((nav) => ({
                  key: nav.key,
                  title: translate(nav.title),
                  label: nav?.children?.length ? (
                    translate(nav.title)
                  ) : (
                    <Link to={nav.url || ""}>{translate(nav.title)}</Link>
                  ),
                  icon: nav.icon,
                  type: nav?.type,
                  children: nav?.children?.map((children) => getChildren(children))
                }))
              : flattenNavItems(navbar).map((nav) => ({
                  key: nav.key,
                  title: translate(nav.title),
                  label: nav?.children?.length ? (
                    translate(nav.title)
                  ) : (
                    <Link to={nav.url || ""}>{translate(nav.title)}</Link>
                  ),
                  icon: nav.icon,
                  type: nav?.type,
                  children: nav?.children?.map((children) => getChildren(children))
                }))
          }
          mode="inline"
        />
      </div>
    </Sider>
  )
}

Sidebar.propTypes = {
  collapsed: PropTypes.bool
}
